import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { CancelAction, CancelGetter } from '@/store/cancel/cancel.module';
import { Cancel } from '@/store/cancel/cancel.model';
import { ProjectAttachment } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectCancelImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    projectId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const cancel = computed<Cancel | undefined>(() => store.getters[CancelGetter.GET]);
    const images = computed<ProjectAttachment[]>(() => (cancel.value) ? cancel.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[CancelGetter.STATUS] === 'init' || store.getters[CancelGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(CancelAction.ADD_ATTACHMENTS, {
        projectId: props.projectId,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(CancelAction.REMOVE_ATTACHMENTS, {
              projectId: props.projectId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
